var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"className":"main-section"}},[_c('img',{attrs:{"src":require('@/assets/images/wm-promotion/main-section/8.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }